import { useEffect } from 'react';
import { getAllMyMultisigs, getArchivedMultisigs, getPendingMultisigs } from 'api';
import useAddress from 'hooks/use-address';
import useNetwork from 'hooks/use-network';
import { useArchivedSafes, usePendingSafes, useSafes } from 'store';
import { StxChain } from 'types/api/ApiResponseTypes';
import { StxChainEnum } from 'types/enums';

export const useLoadSafes = (handleLoading: (val: boolean) => void) => {
  const walletAccount = useAddress();
  const [network] = useNetwork();
  const { setSafes } = useSafes();
  const { setPendingSafes } = usePendingSafes();
  const { setArchivedSafes } = useArchivedSafes();
  const net = StxChainEnum[network] as any as StxChain;

  const fetchData = async () => {
    handleLoading(true);
    try {
      const pendingMulitisgsResponse = await getPendingMultisigs(net);

      const multisigsResponse = await getAllMyMultisigs(net);

      const archivedMultisigsResponse = await getArchivedMultisigs(net);

      setArchivedSafes(archivedMultisigsResponse);
      setPendingSafes(pendingMulitisgsResponse);
      setSafes(multisigsResponse);
    } catch (error) {
      console.error(error);
    } finally {
      handleLoading(false);
    }
  };

  useEffect(() => {
    if (!walletAccount) return;
    fetchData();

    const intervalId = setInterval(() => {
      fetchData();
    }, 60e3);

    return () => {
      clearInterval(intervalId);
    };
  }, [walletAccount, network]);
};
